//@ts-check
import searchFields from './searchFields';
import updateFields from './updateFields';
/**
 * @param {import("../logic/types").EcrionFormState} state
 * @param {Array<import("./types").SearchAndUpdateOptions>} options
 */

var searchAndUpdateFields = function searchAndUpdateFields(state, dispatch, options) {
  if (!state || !state.fields) return; // no fields to search for

  /** @type {Array<import('./types').UpdateFieldOptions>}*/

  var updateOptions = [];
  options.forEach(function (option) {
    // for each option, search the fields
    searchFields(state, option).forEach(function (field) {
      return updateOptions.push({
        id: field.id,
        updateProperties: option.updateProperties
      });
    });
  }); // now we can update fields

  updateFields(state, dispatch, updateOptions);
};

export default searchAndUpdateFields;